import React, { useEffect } from 'react';
import moment from 'moment';
import {connect} from 'react-redux'
import { Grid } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { Button, Divider, CardHeader } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { store } from '../../Store'
import axios from '../../httpClients/axios-datamerch'
import { useLocation, useNavigate } from 'react-router'

import * as actions from '../../store/actions'

import {RecentMerchantsByCategory} from '../../components'
import {TotalMembers} from '../../components'
import {TotalUsers} from '../../components'
import {TotalMerchants} from '../../components'
import {TotalNotes} from '../../components'
import {TotalMonthlyRevenue} from '../../components'
import {TopContributors} from '../../components'
import {BottomContributors} from '../../components'
import {SearchesByDay} from '../../components'
import {AdditionsByDay} from '../../components'
import {SearchesBySource} from '../../components'
import {HitsByCategory} from '../../components'
import {MessageBar} from '../../components'
import {UploadPercentWarningDialog} from '../../components'
import {SearchHistoryCorrelation} from '../../components' 




import {SearchInput} from './../../components'
import useClasses from '../../helpers/useClasses';

const styles = theme => ({
  root: {
    padding: theme.spacing(4)
  },
  button: {
    backgroundColor: '#43a047',
    color: '#fff',
    padding: '13px 5px 13px 5px'
  },
  divider: {
    margin: '40px 0'
  },
  dividerMinHeight: {
    margin: '0px 0 10px 0'
  },
  noUnderline: {
    textDecoration: 'none'
  }
});

const Dashboard = (props) => {
  const { 
    onMerchantSearchClick,
    onFetchDashboardUpdates,
    token,
    is_dm_admin,
    account_id,
    onLoadAppSettings,
    dashboard_message_enabled,
    dashboard_message_severity,
    dashboard_message_title,
    dashboard_message,
    user
  } = props
  const classes = useClasses(styles);

  useEffect(() => {
    onFetchDashboardUpdates(user);
  }, [])

  let navigate = useNavigate()

  const merchantSearch = (search, token) => {
    return { type: 'SEARCH_MERCHANTS', search: search, token: token }
  };

  const handleMerchantSearchClick = (event, search) => {
    event.preventDefault();
    store.dispatch(merchantSearch(search, token))
    navigate("/search")
  }

  const logoutUser = () => {
    return { type: 'LOGOUT_USER' }
  };

  // if (!user.account_total_ninety_days_contribution_percentage){
  //   store.dispatch(logoutUser())
  // }

  return (
    <div>
      {/* <MessageBar
          severity={'success'}
          richContent={true}
          title={'Introducing DataMerch PRO!'}
          message={dashboard_message}
        /> */}
      {/* {user.account_total_ninety_days_contribution_percentage < 0.5 ?
        <MessageBar
          severity={'error'}
          title={'Sharing Contribution Warning'}
          message={'Your company DataMerch account is under the minimum contribution percentage of 0.5%.  Please upload default, suspicious activity, slow pay, etc. merchants to bring your contribution percentage above 0.5%. Contribution percentage is recalculated daily, or if you an admin for your account, you can manually refresh under “account” and “contribution” tab.'}
        />
      : null } */}
      {dashboard_message_enabled ?
        <MessageBar
          severity={dashboard_message_severity}
          title={dashboard_message_title}
          message={dashboard_message}
        />
      : null }
      <div className={classes.root}>
        <Grid
          container
          spacing={4}
        >
          <Grid
            size={{xs:12, sm:12, lg: 6, xl:6}}
          >
            <CardHeader title="Search for a Merchant" />
            <Divider
              // className={classes.dividerMinHeight}
              sx={{
                margin: '0px 0 10px 0'
              }}
            />
            <SearchInput
              className={classes.searchInput}
              placeholder="Search for merchant by full EIN or legal name"
              onSearchClick={(event, search) => handleMerchantSearchClick(event, search)}
              user={user}
            />
          </Grid>
          <Grid
            size={{xs:12, sm:12, lg: 6, xl:6}}
          >
            <CardHeader title="Add a New Merchant" />
            <Divider
              // className={classes.dividerMinHeight}
              sx={{
                margin: '0px 0 10px 0'
              }}
            />
            <RouterLink to="/merchants/new" className={classes.noUnderline}>
              <Button
                variant="contained"
                // className={classes.button}
                startIcon={<AddIcon />}
                fullWidth={true}
                sx={{
                  backgroundColor: '#43a047',
                  color: '#fff',
                  padding: '13px 5px 13px 5px'
                }}
              >
                Add Merchant
              </Button>
            </RouterLink>
          </Grid>
        </Grid>
        <Divider
          // className={classes.divider}
          sx={{
            margin: '40px 0'
          }}
        />
        <Grid
          container
          spacing={4}
        >
          {is_dm_admin ? 
            <React.Fragment>
              <Grid
                size={{xs:12, sm:6, lg: 6, xl:6}}
              >
                <TotalMerchants />
              </Grid>
              <Grid
                size={{xs:12, sm:6, lg: 6, xl:6}}
              >
                <TotalNotes />
              </Grid>
              <Grid
                size={{xs:12, sm:6, lg: 4, xl:4}}
              >
                <TotalMembers />
              </Grid>
              <Grid
                size={{xs:12, sm:6, lg: 4, xl:4}}
              >
                <TotalUsers />
              </Grid>
              <Grid
                size={{xs:12, sm:6, lg: 4, xl:4}}
              >
                <TotalMonthlyRevenue />
              </Grid>
              <Grid
                size={{xs:12, sm:12, lg:12, xl:12}}
              >
                <SearchesByDay />
              </Grid>
              <Grid
                size={{xs:12, sm:12, lg: 4, xl:4}}
              >
                <SearchesBySource />
              </Grid>
              <Grid
                size={{xs:12, sm:12, lg:8, xl:8}}
              >
                <HitsByCategory />
              </Grid>
              <Grid
                size={{xs:12, sm:12, lg:12, xl:12}}
              >
                <AdditionsByDay />
              </Grid>
              <Grid
                size={{xs:12, sm:12, lg:6, xl:6}}
              >
                <TopContributors />
              </Grid>
              <Grid
                size={{xs:12, sm:12, lg:6, xl:6}}
              >
                <BottomContributors />
              </Grid>
              <Grid
                size={{xs:12, sm:12, lg:12, xl:12}}
              >
                <SearchHistoryCorrelation />
              </Grid>
              <Grid
                size={{xs:12, sm:12, lg:12, xl:12}}
              >
                <RecentMerchantsByCategory category="All" perpage="200" />
              </Grid>
            </React.Fragment>
          : null}
          {!is_dm_admin ?
            <React.Fragment>
              <Grid
                size={{xs:12, sm:12, lg:12, xl:12}}
              >
                <HitsByCategory />
              </Grid>
              <Grid
                size={{xs:12, sm:12, lg:12, xl:12}}
              >
                <SearchHistoryCorrelation />
              </Grid>
            </React.Fragment>
            : null }
          <Grid
            size={{xs:12, sm:12, lg:12, xl:12}}
          >
            <RecentMerchantsByCategory category="Suspicious Activity" />
          </Grid>
        </Grid>
      </div>
      {/* {console.log(user.account_total_ninety_days_contribution_percentage)}
      {console.log(user.upload_percent_warning_dismiss)} */}
      {/* {console.log(user.upload_percent_warning_dismiss === null )}
      {console.log(moment(user.upload_percent_warning_dismiss).add(30, 'days').isBefore(new Date()))} */}
      {/* {(user.account_total_ninety_days_contribution_percentage < 0.5 && (user.upload_percent_warning_dismiss === null || (user.upload_percent_warning_dismiss && moment(user.upload_percent_warning_dismiss).add(30, 'days') < (new Date())))) ? */}
      {/* {(user.account_total_ninety_days_contribution_percentage < 0.5 && (user.upload_percent_warning_dismiss === null)) ? */}
        <UploadPercentWarningDialog
          // open={(user.account_total_ninety_days_contribution_percentage < 0.5 && (user.upload_percent_warning_dismiss === null))}
        >
        </UploadPercentWarningDialog>
      {/* : null } */}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    token: state.auth.token,
    is_admin: state.auth.user.is_admin,
    is_dm_admin: state.auth.user.is_dm_admin,
    account_id: state.auth.user.account_id,
    dashboard_message_enabled: state.appSettings.dashboard_message_enabled,
    dashboard_message_severity: state.appSettings.dashboard_message_severity,
    dashboard_message_title: state.appSettings.dashboard_message_title,
    dashboard_message: state.appSettings.dashboard_message,
    user: state.auth.user
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onFetchDashboardUpdates: (user) => dispatch(actions.fetchDashboardUpdates(user)),
    onMerchantSearch: (token, search, user) => dispatch(actions.searchMerchants(token, search, user)),
    onMerchantSearchReset: (token) => dispatch(actions.searchMerchantsReset(token))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard, axios)

